export default __webpack_public_path__ + "static/media/shopcard.9248f2dd.jpg";